import { type ReactElement, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export default function AuthLayout ({ children }: Props): ReactElement {
  return (
    <div
      className='min-h-screen flex items-center justify-center py-10 px-5'
      style={{
        background: '#0D1420',
        backgroundImage:
          'radial-gradient(ellipse at 25% 20%, rgba(53,71,193,.4) 0, transparent 55%), radial-gradient(ellipse at 75% 80%, rgba(53,71,193,.2) 0, transparent 45%)'
      }}
    >
      {children}
    </div>
  )
}
